import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthService } from '../services/api';
import logo from '../assets/logo.png'; // Assumant que le logo est au même endroit
import Message from './Message';

const LostPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(''); // Pour les erreurs de validation ou autres

    const handleChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); // Réinitialiser les erreurs
        setMessage(''); // Réinitialiser le message
        setLoading(true);

        if (!email) {
            setError('Veuillez saisir votre adresse e-mail.');
            setLoading(false);
            return;
        }

        try {
            await AuthService.lostPassword(email);
            // Afficher le message de succès/information quel que soit le résultat de l'API
            setMessage('Si votre adresse mail est connue dans notre base, vous allez recevoir un email pour réinitialiser votre mot de passe.');
        } catch (err) {
            // Ce bloc catch est surtout pour les erreurs inattendues,
            // car AuthService.lostPassword est conçu pour ne pas révéler si l'email existe.
            console.error('Erreur inattendue lors de la demande de mot de passe oublié:', err);
            setError('Une erreur technique est survenue. Veuillez réessayer plus tard.');
        } finally {
            setLoading(false);
            setEmail(''); // Vider le champ email après la soumission
        }
    };

    return (
        // Utiliser la même classe que signin-container pour hériter des styles
        <div className="signin-container">
            {/* Appliquer le même style de logo que SignIn */}
            <img src={logo} alt="Logo de l'application" style={{ maxWidth: '150px', display: 'block', margin: '0px auto 20px auto' }} />
            <h2>Mot de passe oublié</h2>

            {message && <Message type="success">{message}</Message>}
            {error && <Message>{error}</Message>}

            {!message && (
                <form onSubmit={handleSubmit}>
                    {/* Utiliser la classe form-group */}
                    <div className="form-group">
                        <label htmlFor="email">Adresse e-mail</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={email}
                            onChange={handleChange}
                            required
                        // Les styles des inputs sont déjà dans App.css
                        />
                    </div>

                    {/* Le bouton héritera des styles globaux */}
                    <button type="submit" disabled={loading}>
                        {loading ? 'Envoi en cours...' : 'Réinitialiser le mot de passe'}
                    </button>
                </form>
            )}

            {/* Le paragraphe et le lien hériteront des styles globaux */}
            <p>
                <Link to="/signin">Retour à la connexion</Link>
            </p>
        </div>
    );
};

export default LostPassword;